import React from "react";
import { DroneEntity, DroneStatusType } from "@src/core/features";
import { ArcDrone } from "@src/core/components";
import ToggleCollapseView from '@src/features/drone/pages/drones-page/components/toggle-collapse-view';
import { ArcStack } from "@src/core/ui";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setHoveredDrone } from "@src/features/drone/redux/actions";
import { UpdateRequiredSectionsProps } from "./types";
import { routesConfig } from "@src/core/routes";


export const UpdateRequiredSections: React.FC<UpdateRequiredSectionsProps> = (props) => {
  const { drones } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Axis B (OTA verdict): the category only exists when at least one drone reports
  // `ota.updateRequired`. With none, render nothing — no header, no empty collapse.
  // MISSION/IDLE stay visible-when-empty; only this section is fully hidden.
  if (drones.length === 0) {
    return null;
  }

  const onOpenInFleet = (drone: DroneEntity) => {
    dispatch(setHoveredDrone(null));
    navigate(`${routesConfig.fleet}?droneId=${drone.id}`);
  };

  const handleMouseEnter = (drone: DroneEntity) => {
    dispatch(setHoveredDrone(drone));
  };

  const handleMouseLeave = () => {
    dispatch(setHoveredDrone(null));
  };

  return (
    <ToggleCollapseView
      count={drones.length}
      status={DroneStatusType.UPDATE_SOFTWARE_REQUIRED}>
      <ArcStack spacing={1} marginTop={2}>
        {drones.map((drone) => (
          <ArcDrone.primary
            key={drone.id}
            drone={drone}
            onClick={() => onOpenInFleet(drone)}
            onMouseEnter={() => handleMouseEnter(drone)}
            onMouseLeave={handleMouseLeave}
          />
        ))}
      </ArcStack>
    </ToggleCollapseView>
  );
};
